import React from "react";
import styles from "./styles.css";
import { Text } from "@cars24/turbo-web/lib/text";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import PropTypes from "prop-types";
import ArrowIcon from "../arrow";
import { Badge } from "@cars24/turbo-web/lib/badge";

const CarInfoCard = ({
    car,
    badge
}) => {
    const { listingImage = {} } = car || {};
    const { tokens } = useTokens();

    return (
        <div
            styleName={`styles.carCardWrapper`}
        >
            {listingImage && (
                <div styleName={"styles.carImage"}>
                    <img
                        src={listingImage?.bgRemovedUri || listingImage?.uri}
                        alt={listingImage?.key}
                        height={57}
                        width={114}
                    />
                </div>
            )}
            <div styleName={"styles.carDetail"}>
                <div styleName={"styles.sectionHeader"}>
                    <div styleName={"styles.regNo"}>
                        <Text size={"150"} fontWeight="semibold">
                            {car.regNumber}
                        </Text>
                    </div>
                    {
                        badge && (
                            <Badge {...badge} />
                        )
                    }
                </div>
                <div styleName="styles.contentSection">
                    <div>
                        <Text fontWeight={"bold"} size={"200"}>
                            {car.year} {car.make} {car.model}
                        </Text>
                        <Text
                            size={"200"}
                            ellipsis
                            color={tokens.text_default_text_secondary}
                        >
                            {car.variant} | {car.year} | {car.fuelType}
                        </Text>
                    </div>
                    <ArrowIcon black={true} rotateBy={-90} />
                </div>
            </div>
        </div>
    );
};

CarInfoCard.propTypes = {
    car: PropTypes.object,
    onClick: PropTypes.func,
    badge: PropTypes.object
};

export default CarInfoCard;
